<template>
  <div class="pricing-table-row list_panel" :class="customClass">
    <span
      :title="title"
    >
      <slot
        name="description"
      />
    </span>
    <span>
      <slot
        name="value"
      />
    </span>
  </div>

</template>

<script>
export default {
  props: {
    customClass: String,
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
